import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';

const AuthUserInternalManagerRoute = () => {
  const { apiUser, loading: isAuthLoading } = useContext(AuthContext);

  if (isAuthLoading || !apiUser) return <></>;

  if (apiUser.organizationid === 401 && (apiUser.role === 'Admin' || apiUser.role === 'Manager'))
    return <Outlet />;
  return <></>;
};

export default AuthUserInternalManagerRoute;
